module.exports = __webpack_public_path__ + "static/img/73-2.bf40d7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/73-2.jpg
// module id = hKU/
// module chunks = 0